<template>
  <div :class="$vuetify.breakpoint.xs ? 'background' : ''">
    <v-main>
      <v-container>
        <div v-if="$vuetify.breakpoint.xs">
          <v-card
            style="
              padding: 44px 26px 55px 26px;
              margin-bottom: 150px;
              box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
              border-radius: 16px;
              margin-top: 48px;
            "
          >
            <v-col style="text-align: center" class="px-0">
              <img
                style="margin-top: 18px"
                width="178px"
                height="178px"
                src="@/assets/img/mobileAuthIcons/emailIcon.svg"
              />
              <p
                style="
                  font-family: 'Gilroy-Bold';
                  font-size: 32px;
                  line-height: 38px;
                  color: #5e5e5e;
                  margin-top: 20px;
                "
              >
                <strong
                  >{{ "mobile_registration_email_verification_h1" | localize }}
                </strong>
              </p>
              <p style="text-align: center">
                {{ "mobile_registration_email_verification_label1" | localize }}
              </p>
              <p style="text-align: center">
                {{
                  "mobile_registration_email_verification_label_2" | localize
                }}
                <strong>
                  <span style="color: #73afe7; font-size: 14px">{{
                    $route.query.email
                  }}</span>
                </strong>
                {{
                  "mobile_registration_email_verification_label_3" | localize
                }}
              </p>
            </v-col>
          </v-card>
        </div>
        <div
          v-else
          class="
            justify-center
            align-center
            mx-auto
            col-12 col-sm-7 col-md-4
            my-15
          "
        >
          <v-card class="px-5">
            <v-card-title class="mb-3">{{
              "success_registration_title" | localize
            }}</v-card-title>
            <v-card-text>
              {{ "success_registration" | localize }}
            </v-card-text>
          </v-card>
        </div>
      </v-container>
    </v-main>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$vuetify.goTo(0, 0);
  },
};
</script>

<style>
.background {
  background-image: url("../assets/img/mobileAuthIcons/mobileBackground.svg");
  height: 800px;
  width: 100%;
  background-size: auto;
  background-repeat: repeat;
}
</style>
